module.exports = __webpack_public_path__ + "static/img/zh_CN2.684e1ca.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/mobile/zh_CN2.png
// module id = eK14
// module chunks = 1